import { Component, OnInit } from '@angular/core';
import {MessageService} from 'primeng/api';
import { Router } from '@angular/router';
import { TableColumn } from 'src/app/shared-components/data-table/data-table.component';
import { StorageService } from 'src/app/services/storage.service';
// import { UserManagementService } from 'src/app/services/user-management.service';


interface City {
  name: string,
  code: string
}


@Component({
    selector: 'app-user-management-form',
    templateUrl: './user-management-form.component.html',
    styleUrls: ['./user-management-form.component.scss'],
    standalone: false
})
export class UserManagementFormComponent implements OnInit {
  readonly userColumns: TableColumn[] = [
    { field: 'si_no', header: 'SI No' },
    { field: 'name', header: 'Name' },
    { field: 'role', header: 'Role' },
    { field: 'email', header: 'Email ID' },
    { field: 'mobile', header: 'Mobile No' },
    { field: 'created_on', header: 'Created on' },
    { field: 'status', header: 'Status' },
    { field: 'action', header: 'Action', toggleable: false, draggable: false },
  ];

  isActive: boolean = false;
  isActive1: boolean = true; 
  isActive2: boolean = true; 
  isActive3: boolean = false;
  isActive4: boolean = false;
  Users: any = [];
  cities: City[];
  selectedCity!: City;
  pageNo: number = 1;
  totalRecords:number = 10;
  userRole: string;
  constructor(private messageService: MessageService, private router: Router, private storageService: StorageService) {
      // private userManagementService=UserManagementService

    this.cities = [
      {name: 'Rome', code: 'RM'},
      {name: 'London', code: 'LDN'},
      {name: 'Istanbul', code: 'IST'},
      {name: 'Paris', code: 'PRS'}
  ];

  }

  ngOnInit(): void {
    this.userRole = this.storageService.getRole() || '';
  }

 
  savePersonalDetails(){

  }

  showSuccess() {
        this.messageService.add({severity:'custom', summary: 'User deleted successfully!', detail: 'Lorem ipsum dolar sit.', icon: 'pi-check-circle'});
    }

   showError() {
  this.messageService.add({severity:'custom1', summary: 'custom1', detail: 'Message Content'});
}

back(){
  this.userRole === 'CLIENT'
    ? this.router.navigate(['doqfy/dashboard'])
    : this.router.navigate(['doqfy/admin-dashboard']);
}



onPageChange(event:any){
   }

}



